module.exports = __webpack_public_path__ + "img/border3.4b92496b.png";